import { Dropdown } from 'primereact/dropdown'
import styled from 'styled-components'

export const PriceInfo = styled.div`
  padding: 0 0.5rem;
  display: flex;
  align-items: center;
  column-gap: 0.25rem;
  color: #a8a8a8;
  font-weight: 400;
  font-size: 12px;
  line-height: 14px;

  .price {
    margin-left: 2px;
    font-weight: 700;
  }
`
export const DropdownWrapper = styled.div`
  position: relative;
  .autocomplete-title {
    position: absolute;
    left: 35px;
  }

  .autocomplete-icon {
    position: absolute;
    left: 8px;
    top: 16px;
    z-index: 1;
    color: #a8a8a8;
  }

  .selectedVal,
  .p-dropdown .p-dropdown-label {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .selectedVal {
    font-size: 14px;
    margin-top: 0.5rem;
    margin-left: 0.1rem;
    font-weight: 700;
  }

  .p-dropdown .p-dropdown-label {
    padding-left: 2rem;
    padding-right: 0;
  }
`
export const StyledCustomDropdown = styled(Dropdown)`
  width: 100%;
  height: 50px;
  border-radius: 10px;
  align-items: center;

  .p-dropdown-panel {
    z-index: 1004 !important;
    position: absolute !important;
    left: 0px !important;
    top: 52px !important;
    min-width: 100% !important;
    min-height: 100% !important;
    background: #ffffff !important;
    transform-origin: center top !important;
  }

  .p-dropdown-items-wrapper {
    max-height: 220px !important;
    max-width: 530px !important;

    &::-webkit-scrollbar-track {
      -webkit-box-shadow: none !important;
      background-color: #d3d3d3 !important;
      border-radius: 10px;
    }

    &::-webkit-scrollbar {
      height: 6px;
      width: 6px !important;
      background-color: #d3d3d3;
      border-radius: 10px;
    }

    &::-webkit-scrollbar-thumb {
      background-color: #7c7c7c;
      border-radius: 10px;
    }
  }

  &.coiffeur-dropdown {
    .p-dropdown-items-wrapper {
      max-height: 200px !important;
      max-width: 530px !important;
    }


    &.coiffeur-calendar{
      .p-dropdown-items-wrapper {
      max-height: 150px !important;
      max-width: 530px !important;
      }
    }

    .p-dropdown-panel {
      top: 55px !important;
      background: #ffffff !important;
      box-shadow: none !important;
      border: 1px solid #cecece;
    }

    .p-dropdown-items {
      padding: 0 !important;
    }

    .p-dropdown-item {
      padding: 0 10px;
      border-top: 1px solid #cecece;
      border-bottom: 1px solid #cecece;

      &:first-of-type {
        border-top: none !important;
      }
      &:last-of-type {
        border-bottom: none !important;
      }
    }

    .p-dropdown-item:not(.p-highlight):not(.p-disabled):hover {
      border-radius: 15px !important;
          //   &:first-of-type {
          //     border-radius: 15px 15px 15px 15px !important;
          //   }
          //   &:last-of-type {
          //     border-radius: 15px 15px 15px 15px !important;
          //   }
      }
      .p-dropdown-item.p-highlight {
        border-radius: 15px !important;

          // &:first-of-type {
          //   border-radius: 15px 15px 15px 15px !important;
          // }
          // &:last-of-type {
          //   border-radius: 0 0 15px 15px !important;
      }
    }
  }
`
export const StyledDropdownItems = styled.div`
  padding: 0.5rem 0.2rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100% !important;

  .coiffeur-info {
    margin-left: 8px;
    color: #363636;
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-wrap: wrap;

    .coiffeur-name-specialty {
      display: flex;
      align-items: center;
      column-gap: 4px;
    }
  }
`
export const SearchModalHeader = styled.div`
  margin-bottom: 20px;
  color: #363636;

  .dialog-header {
    font-weight: 700;
  }

  .dialog-subheader {
    display: flex;
    flex-direction: column;
    row-gap: 6px;
    font-size: 14px;
    color: #222e47;

    .name {
      font-weight: 700;
      font-size: 14px;
      line-height: 17px;
    }

    .location {
      font-size: 12px;
      line-height: 14px;
    }

    .services {
      font-size: 12px;
      line-height: 14px;
      color: #646464;
    }
  }
`
